import { useQueryParamChange } from "@circle-react/hooks/useQueryParamChange";
import { CurrencySelector } from "@circle-react-shared/Billing/CurrencySelector";
import { usePlans } from "./PlansContext";

export const BillingCurrency = () => {
  const {
    shouldRenderBillingCurrency,
    billingCurrency,
    isRedesignedPlansPage,
  } = usePlans();
  const setQueryParam = useQueryParamChange();

  return shouldRenderBillingCurrency ? (
    <CurrencySelector
      billingCurrency={billingCurrency}
      onCurrencyChange={currency => setQueryParam("billing_currency", currency)}
      isRedesignedPlansPage={isRedesignedPlansPage}
    />
  ) : null;
};
